import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { CircularProgress, Dialog, DialogContent } from "@mui/material";
import { useApiLoginMutation } from "../Store/Middleware/api/loginAPI";
import GoogleAuth from "./GoogleAuth";
import axios from "axios";
import { useLinkedIn } from "react-linkedin-login-oauth2";
import linkedin from "react-linkedin-login-oauth2/assets/linkedin.png";
import { toast } from "react-toastify";
import { BorderColor } from "@mui/icons-material";
import { useReducer } from "react";

export default function SignupPopup({ isOpen, setIsOpen }) {
  const { linkedInLogin } = useLinkedIn({
    clientId: `${process.env.REACT_APP_LINKEDIN_CLIENT_ID}`,
    redirectUri: `${window.location.origin}/linkedin`,
    onSuccess: async (code) => {
      setIsOpen(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/linkedin-login`,
          {
            code: code,
          },
        );
        const user = response?.data?.message?.result_email;
        const token = response?.data?.message?.token;

        if (!user || !token) throw new Error("Invalid response from server");

        localStorage.setItem("id", user.id);
        localStorage.setItem("email", user.email);
        localStorage.setItem("name", user.name);

        const d = new Date();
        d.setTime(d.getTime() + 1 * 60 * 60 * 1000);
        let expires = "expires=" + d.toUTCString();
        document.cookie = `authToken=${token};${expires};path=/`;

        if (window.opener) {
          window.opener.location.href = "/authPage/jobdetails/openposition";
          window.close();
        } else {
          window.location.href = "/authPage/jobdetails/openposition";
        }
      } catch (error) {
        console.log("error", error);
        toast.error("Please Try Again!", {
          hideProgressBar: true,
          closeOnClick: true,
        });
      }
    },
    onError: (error) => {
      console.log("error", error);
    },
    scope: "openid+profile+w_member_social+email",
  });

  const initialState = {
    email: "",
    error: "",
  };

  const reducer = (state, action) => {
    if (action.type === "set Email") {
      return {
        ...state,
        email: action.payload,
      };
    }
    if (action.type === "set Error") {
      return {
        ...state,
        error: action.payload,
      };
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  const [apiLogin, result] = useApiLoginMutation();
  const handleClose = () => {
    setIsOpen((prev) => ({
      ...prev,
      isSignupOpen: !isOpen.isSignupOpen,
    }));
  };

  const handleSubmit = async () => {
    if (!state.email) {
      dispatch({
        type: "set Error",
        payload: "Please Enter The Email Address",
      });
      return;
    } else if (
      !state.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/)
    ) {
      dispatch({ type: "set Error", payload: "Invalid Email Address" });
      return;
    } else {
      localStorage.setItem("userID", state.email);
      let emailData = state.email;
      const response = await apiLogin({ email: emailData });
      if (response?.data?.success) {
        setIsOpen((prev) => ({
          ...prev,
          isSignupOpen: false,
          isOTPOpen: true,
        }));
      }
    }
  };

  return (
    <div>
      <React.Fragment>
        <Dialog
          open={isOpen && isOpen.isSignupOpen}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
        >
          <DialogContent>
            <Box>
              <div
                id="modal-modal-title"
                variant="h6"
                component="h2"
                className="login-popup-heading"
              >
                Sign Up
              </div>
              <div className="login-popup-input">
                <label className="sign-up-label">Sign up With Email</label>
                <div className={`input-group ${!state.error && "mb-3"}`}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Email"
                    maxlength="60"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    // onChange={(e) => setEmail(e.target.value)}
                    onChange={(e) =>
                      dispatch({ type: "set Email", payload: e.target.value })
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        handleSubmit();
                      }
                    }}
                  />
                </div>
                {state.error && (
                  <div>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "red",
                        fontWeight: "500",
                      }}
                    >
                      {state.error}
                    </span>
                  </div>
                )}
              </div>
              <div style={{ paddingTop: "16px" }}>
                {result.isLoading ? (
                  <Button variant="contained" fullWidth disabled>
                    <CircularProgress color="inherit" />
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    sx={{
                      background: "#38c4ec",
                      "&:hover": {
                        background: "#38c4ec",
                      },
                    }}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                )}
              </div>
              <div
                className="d-flex align-items-center overflow-hidden my-2"
                style={{ paddingTop: "15px" }}
              >
                <img src="/loginLine.png" alt="error" width="45%" />
                <span className="px-2 fs-16">Or</span>
                <img
                  src="/loginLine.png"
                  alt="error"
                  width="50%"
                  className=""
                />
              </div>
              <div style={{ paddingTop: "24px", display: "none" }}>
                <div className="login-with-text">Sign up with</div>
              </div>
              <div className="login-btn-btn-login">
                <Button
                  variant="outlined"
                  sx={{
                    width: "176px",
                    height: "60px",
                    borderColor: "#38c4ec",
                    "&:hover": {
                      borderColor: "#38c4ec",
                    },
                  }}
                >
                  <img src="/google.png" className="login-btn-btn-login-img" />
                  <span className="login-btn-btn-login-text">Google</span>
                  <div className="gtagClass">
                    <GoogleAuth isOpen={isOpen} setIsOpen={setIsOpen} />
                  </div>
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    width: "230px",
                    height: "60px",
                    borderColor: "#38c4ec",
                    "&:hover": {
                      borderColor: "#38c4ec",
                    },
                  }}
                  onClick={linkedInLogin}
                >
                  <img
                    src="/login_linkedin.png"
                    className="login-btn-btn-login-img"
                  />{" "}
                  <span className="login-btn-btn-login-text">LinkedIn</span>
                </Button>
              </div>
              {/* <div
                className="login-signup-text-main"
                style={{ justifyContent: "space-evenly" }}
              >
                <div className="login-signup-text">
                  Already have an account yet?
                </div>
                <Button variant="contained">
                  Sign In
                </Button>
              </div> */}
            </Box>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  );
}
